import React, { Component } from 'react';
import { Form, Label, Button, Dropdown } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class BloodType extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="BloodType">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="BloodType__Form"
        >
          <h1>{translate('fiche.blood_type.title')}</h1>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.blood_type.blood_type')} />
              <Dropdown
                name="blood_type"
                data={translate('fiche.blood_type.types')}
                rules={['required']}
                defaultValue={data.blood_type}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.blood_type.rhesus_factor')} />
              <Dropdown
                name="rhesus_factor"
                data={['+', '-']}
                rules={['required']}
                defaultValue={data.rhesus_factor}
              />
            </div>
          </div>

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(BloodType);
